import { gql } from "graphql-tag";

export const WAITLIST_UPDATE_METADATA = gql`  
  query WaitlistUpdateMetadata(
    $id: ID!
  ) {
    interestList(id: $id) {
      id
      name
      scheduledUpdate {
        enabled
        begins
        ends    
      }
    }
  }
`;

export const WAITLIST_UPDATE_QUERY = gql`  
  query WaitlistUpdateQuery(
    $id: ID!, 
    $statuses: [WaitlistUpdateRequestStatus], 
    $limit: Int!, 
    $offset: Int!
  ) {
    interestList(id: $id) {
      id
      name
      scheduledUpdate {
        enabled
        begins
        ends     
        requested(statuses: $statuses, limit: $limit, offset: $offset) {
          totalCount
          results {
            name
            phone
            respondedAt
            status
            interestId
          }
      }
    }
  }
}
`;
export const REQUESTED_COUNTS = gql`
  query RequestedCounts($id: ID!, $statuses: [WaitlistUpdateRequestStatus]) {
    interestList(id: $id) {
      id
      name
      scheduledUpdate {
        requestedCounts(statuses: $statuses) {
          status
          totalCount
        }
      }
    }
  }
`;

export const QUERY_INTEREST_LISTS = gql`
  query WaitlistUpdatesEnabled($id: ID!) {
    organization(id: $id) {
      interestLists {
        id
        name
        type
        scheduledUpdate {
          enabled
        }
      }
    }
  }
`;
